<div class="banner" role="banner">
  <h1>{{ 'tiers.page.title' | translate }}</h1>
</div>

<div class="container">
  <div class="mt-4 font-size-14" [innerHTML]="'tier.page.description' | translate | markdownTranslate"></div>
  <div class="font-heading font-size-25 mt-4">
    {{ 'tier.progress.title' | translate }}
  </div>
  <ng-container *ngIf="tierLevels$ | async as tierLevels">
    <div class="mt-3">
      <div *ngFor="let tier of tierLevels; let last = last; let i = index">
        <fgb-tier-level-progress
          [tier]="tier"
          [tierName]="tierName"
          [isLast]="last"
          [index]="i"
          [selectedIndex]="selectedIndex"
        />
      </div>
    </div>
  </ng-container>
</div>
